import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/icons/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';
import ExamQuestionsView from 'src/views/reports/ExamQuestionsView';

const App = () => {
  const routing = useRoutes([
    ...routes,
    {
      path: 'exam-questions',
      element: <ExamQuestionsView />
    }
  ]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}
    </ThemeProvider>
  );
};

export default App;
